import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AppContext from "contexts/AppContext";
import api from "services/api";
import auth from "services/auth";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Translator, { __ } from "services/Translator";

const LoginBonus = (props) => {
  const isAuthenticated = useSelector((state) => state.userAuth.isAuthenticated);
  const { getUserBalance } = useContext(AppContext);

  // GCC is a real-money casino: a daily-login campaign served by
  // GET /login-bonus/eligibility, claimed via GET /login-bonus/claim.
  const [dailyBonus, setDailyBonus] = useState(null);
  const [claiming, setClaiming] = useState(false);

  useEffect(() => {
    let mounted = true;
    const checkEligibility = async () => {
      if (!isAuthenticated || !auth.isAuthenticated()) {
        setDailyBonus(null);
        return;
      }
      try {
        // api.get never rejects; a 404/4xx comes back as {status, data} and is
        // ignored silently so the widget simply stays hidden.
        const response = await api.get("/login-bonus/eligibility");
        if (mounted && response?.status === 200 && response.data?.campaign) {
          setDailyBonus(response.data);
        }
      } catch (err) {
        // Endpoint unavailable: no daily bonus, render nothing
      }
    };
    checkEligibility();
    return () => {
      mounted = false;
    };
  }, [isAuthenticated]);

  const claimDailyBonus = async () => {
    if (claiming) return;
    setClaiming(true);
    try {
      const response = await api.get("/login-bonus/claim");
      const message = response?.data?.message || "";
      if (response?.status === 200 && response.data?.status === "success") {
        setDailyBonus(null);
        Swal.fire(__("Congratulations!"), __("Your daily bonus is claimed"), "success");
        if (typeof getUserBalance === "function") {
          try {
            getUserBalance();
          } catch (err) {
            // Balance refresh is best-effort; the claim already succeeded.
          }
        }
      } else if (/already|not available/i.test(message)) {
        // Backend Warning: the bonus was already claimed / no longer claimable.
        setDailyBonus(null);
        Swal.fire(__("Daily bonus"), message, "info");
      } else {
        // Transient failure: keep the widget so the player can retry.
        Swal.fire(
          __("Claim failed"),
          message || __("Please try again later."),
          "error"
        );
      }
    } catch (err) {
      Swal.fire(__("Claim failed"), __("Please try again later."), "error");
    } finally {
      setClaiming(false);
    }
  };

  if (dailyBonus) {
    const cashAmount = Number(dailyBonus.cash ?? 0);
    const bonusAmount = Number(dailyBonus.bonus ?? 0);
    const label = cashAmount > 0 ? cashAmount : bonusAmount;
    return (
      <>
        <div className="claim_login_bonus">
          <Link
            hreflang={Translator.getSelectedLanguage().code}
            className="commonBtn pTwoBtn"
            onClick={claimDailyBonus}
          >
            <div class="text-big">
              <img
                alt=""
                src={
                  require("assets/play365/images/coinSwitcher/fun-coin.svg")
                    .default
                }
              />{" "}
              <div>{label}</div>
            </div>
            <div class="text">{__("Claim Daily Bonus")}</div>
          </Link>
        </div>
      </>
    );
  }

  return <></>;
};

export default LoginBonus;
